export default __webpack_public_path__ + "static/media/795-min.fe607a36.png";